import { FeatureFlag } from '@mews-distributor/common';
import { EnvironmentService, FeatureFlagService } from '@mews/framework';
import { getDistributorApiUrl, getPlatformPrimaryUrl } from '../../../modules/configuration/selectors';
import { ApplicationState } from '../../../types';

const isCors = ({
    origin,
    distributorApiUrl,
    platformPrimaryUrl,
}: {
    origin: string;
    distributorApiUrl: string;
    platformPrimaryUrl: string;
}) => {
    try {
        const parsedOriginUrl = new URL(origin);
        const parsedDistributorApiUrl = new URL(distributorApiUrl);
        const parsedPrimaryUrl = new URL(platformPrimaryUrl);

        /*
         * We're purposely not checking things like port etc. as we're only
         * interested in the protocol and hostname. It's unrealistic to think
         * that the port would be different in a production environment.
         */
        return (
            parsedOriginUrl.hostname !== parsedDistributorApiUrl.hostname &&
            parsedOriginUrl.hostname !== parsedPrimaryUrl.hostname
        );
    } catch (e) {
        return true;
    }
};

export const isRecaptchaVerificationEnabled = (
    state: ApplicationState,
    {
        environmentService,
        featureFlagService,
    }: { environmentService: EnvironmentService; featureFlagService: FeatureFlagService }
) => {
    /*
     * On backend, the use of these  feature flags depends on whether the
     * request is CORS or not, so we need to follow the same approach.
     */
    const platformPrimaryUrl = getPlatformPrimaryUrl(state);
    const distributorApiUrl = getDistributorApiUrl(state);
    const cors = isCors({ origin: environmentService.get('location')?.origin, distributorApiUrl, platformPrimaryUrl });

    if (cors) {
        return featureFlagService.hasFlag(FeatureFlag.bookingEngineWidgetRecaptchaVerificationEnabled);
    }

    return featureFlagService.hasFlag(FeatureFlag.bookingEngineStandaloneRecaptchaVerificationEnabled);
};
